import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import themes from 'devextreme/ui/themes';
import * as utils from '../../../common/utils';
import { postUserLog } from '../../../actions/common'
import ACTION_TYPES from '../../../actions/actionTypes'
import { updateTheme } from '../../../reducers/slices/themeSlice';


const ThemeSwitch = () => {
    const dispatch = useDispatch()
    const state = useSelector(state => state.theme.lightMode)

    let isChecked = true, devExTheme = 'generic.dark';

    if (utils.get('themeVal') !== undefined) {
        isChecked = utils.get('themeVal');
        devExTheme = isChecked ? 'generic.dark' : 'generic.light'
    }

    const [defaultTheme, setDefaultTheme] = useState(devExTheme);
    const [checked, setChecked] = useState(isChecked)

    const changeTheme = React.useCallback((e) => {
        let themeVal = defaultTheme === 'generic.light' ? 'generic.dark' : 'generic.light';
        themes.current(themeVal);
        setDefaultTheme(themeVal);
        setChecked(!checked);
        utils.set('themeVal', !checked)
        dispatch(updateTheme(!state))
        //dispatch({ type: ACTION_TYPES.THEME_UPDATE, payload: !checked });
        document.documentElement.setAttribute("data-theme", themeVal === 'generic.light' ? 'light' : 'dark');
        let themeInfo = themeVal === 'generic.light' ? 'light' : 'dark'
        postUserLog({ event: 'Theme Change', data: { action: 'Theme Changed to ' + themeInfo, module: 'Theme', section: '', } })
    }, [defaultTheme, checked]);

    return (
        <>
            <div className="theme-switcher">
                <span className="text light">Light</span>
                <label className="switch" htmlFor="switchTheme">
                    <input type="checkbox" id="switchTheme" onChange={changeTheme} checked={checked} />
                    <span className="slider"></span>
                </label>
                <span className="text dark">Dark</span>
            </div>
        </>
    );
}



export default connect()(ThemeSwitch)
